import _ from 'lodash'
import { supportedMimeTypesToSend } from '../constants/supportedFileTypes'
import { fileSizeToMB } from 'utils/image'
import { idCreator } from '../utils/idCreator'
import { allSettled } from '../utils/polyfills'

export const validateFiles = async (type, target, selectedChannel) => {
  const files = _.values(target.files)
  const formattedFiles = files.map((file) => {
    return new Promise((resolve, reject) => {
      const validFileSize = fileSizeToMB(file.size) < 10
      file.fileChannel = selectedChannel.url
      file.id = idCreator()
      file.src = URL.createObjectURL(file)
      file.generalType = type

      if (!supportedMimeTypesToSend.includes(file.type)) {
        const error = {
          error: `unsupported ${type} type`,
          errorType: `${type}_type`,
          target: file.name,
        }
        return reject(error)
      }

      if (!validFileSize) {
        const error = {
          error: `exceeded ${type} size`,
          errorType: `${type}_size`,
          target: file.name,
        }
        return reject(error)
      }

      return resolve(file)
    })
  })
  const settledFiles = await allSettled(formattedFiles)

  const successed = settledFiles
    .filter((file) => {
      return file.status === 'fulfilled'
    })
    .map((file) => {
      return file.value
    })

  const failed = settledFiles.filter((file) => {
    return file.status === 'rejected'
  })

  return { successed, failed }
}
